import {
  Display,
  LoadingSpinner,
  LocaleDictionaryType,
  TextColorType,
  useLocales,
} from "@/lib/main";
import { CSSProperties } from "react";

type Props = { color?: TextColorType; message: LocaleDictionaryType };

export default function LoadingMessage({ color = "brand", message }: Props) {
  const l = useLocales();

  const styles: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "var(--spacing-xl)",
  };

  return (
    <div style={styles}>
      <Display color={color} textAlign="center">
        {l(message)}
      </Display>
      <LoadingSpinner color={color} size="display" />
    </div>
  );
}
